import React, {useEffect, useState} from "react";
import {CustomTablePagination, EnhancedSearchTableToolbar} from "../../Utils/Tables/CustomTable";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import *  as snackbarActions from "../../../actions/snackbarActions";
import MainSnackbar from "../../Utils/Snackbar/SmsSnackbar";
import {Container, RightAlignedContainer} from "../../Utils/styledComponents";
import axios from "axios";
import {config} from "../../../Helpers/env";
import {logoutErrorMessage} from "../../../Helpers/ErrorMessages";
import {LoadingGif} from "../../Utils/Loader";
import {CustomTableCell, MuiPaper, StickyHeadTable} from "../../Utils/Tables/StickyHeaderTable";
import PageTitle from "../../Utils/smsTitle";
import {SubHeader} from "../../../Containers/SubHeader";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faClipboardList} from "@fortawesome/free-solid-svg-icons/faClipboardList";
import {BackButton, DataExportButton} from "../../Utils/Buttons/DataExportationButton";
import {useDebounce} from "../../Lab/useDebounce";
import {useExcelReports, usePdfDownload} from "../../Utils/ReusableComponents/useExcelExport";
import { CustomHeadCell } from "../../Utils/Tables/StickyHeaderTable";


const parentHeadData = [
    // {id: 'count', numeric: false, disablePadding: false, label: 'Sl'},
    // {id: 'supplier_name', numeric: false, disablePadding: false, label: 'Supplier Name'},
    {id: '0_to_30', numeric: false, disablePadding: false, label: '0-30 days', colSpan:2},
    {id: '31_to_60', numeric: false, disablePadding: false, label: `31-60 days`, colSpan:2},
    {id: '61_to_90', numeric: false, disablePadding: false, label: `61-90 days`, colSpan:2},
    {id: 'over_90', numeric: false, disablePadding: false, label: `Over 91 days`, colSpan:2},
    {id: 'total', numeric: false, disablePadding: false, label: `Total`, colSpan:2},
];

const headData = [
    { id: 'supplier_name', numeric: false, disablePadding: false, label: 'Supplier Name', isBorder:true },
    { id: 'days_0_30_usd', numeric: false, disablePadding: false, label: 'USD' },
    { id: 'days_0_30_ssp', numeric: false, disablePadding: false, label: 'SSP', isBorder:true},
    { id: 'days_31_60_usd', numeric: false, disablePadding: false, label: 'USD' },
    { id: 'days_31_60_ssp', numeric: false, disablePadding: false, label: 'SSP', isBorder:true },
    { id: 'days_61_90_usd', numeric: false, disablePadding: false, label: 'USD' },
    { id: 'days_61_90_ssp', numeric: false, disablePadding: false, label: 'SSP', isBorder:true },
    { id: 'days_91_plus_usd', numeric: false, disablePadding: false, label: 'USD' },
    { id: 'days_91_plus_ssp', numeric: false, disablePadding: false, label: 'SSP', isBorder:true },
    { id: 'total_usd', numeric: false, disablePadding: false, label: 'Total USD'},
    { id: 'total_ssp', numeric: false, disablePadding: false, label: 'Total SSP' },
];

const CreditorsAgeingReport = ({actions, snackbars}) => {
    const [searchValue, setSearchValue] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(50);
    const [data, setData] = useState({debtors: [], loading: 'idle', total: 0});
    const [debouncedInputValue] = useDebounce(searchValue, 500)
    const [activePage, setActivePage] = useState(1)


    const {loading, debtors, total} = data

    useEffect(() => {
        setData(prevData => ({...prevData, loading: 'pending'}))
        axios.get(`${config.smsUrl}/accounting/creditors_ageing_report`, {
            params: {
                search: debouncedInputValue,
                page: activePage,
                per_page: rowsPerPage
            }
        }).then(res => {
            const dt = res.data || {};
            setData(prevData => ({
                ...prevData,
                loading: 'success',
                debtors: dt.data || [],
                total: dt.total_count || 0
            }))
        }).catch((err) => {
            setData(prevData => ({...prevData, loading: 'error'}))
            logoutErrorMessage(err, null, actions);
        })
    }, [debouncedInputValue, rowsPerPage, activePage, actions]);


    const handleSearch = (event) => {
        setSearchValue(event.target.value)
    };
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        setActivePage(newPage + 1)
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
        setActivePage(1);
    };

    const closeSnackbar = () => {
        actions.snackbarActions.hideSnackbar()
    };


    const excel = {file_name: 'Creditors Ageing Summary', url: 'accounting/creditors_summary_export',params:{ download:1}}
    const pdf = {file_name: 'Creditors Ageing Summary', url: 'accounting/creditors_summary_export',params:{ download:2}}


    const {exportExcel, isLoading: isLoadingExcel} = useExcelReports(actions, excel)
    const {exportPdf, isLoading: isLoadingPdf} = usePdfDownload(actions, pdf)

    // const excel = {file_name:'Purchase Report', url:'creport/purchase_excel', params:{ start_date, end_date, supplier:category.value ? category.value : ''}}

    // const {exportExcel, isLoading} = useExcelReports(actions, excel)



    const {openBar, type, message} = snackbars;

    const isLoading = loading === 'pending'
    const isSuccess = loading === 'success'
    const isError = loading === 'error'


    const pagination = (
        <CustomTablePagination
            colSpan={3}
            activePage={activePage}
            page={page}
            rowsPerPage={rowsPerPage}
            count={total}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            isTotalCount
        />
    );

    
    const parentHead = (
        <TableRow>
            <CustomHeadCell />
            {parentHeadData.map((column) => (
                <CustomHeadCell
                    key={column.id}
                    align='center'
                    style={{ minWidth: column.minWidth }}
                    className={{ root: {} }}
                    colSpan={column.colSpan}
                >
                    <strong>{column.label}</strong>
                </CustomHeadCell>
            ))}
        </TableRow>
    )

    const search_bar = (
        <EnhancedSearchTableToolbar
            term={searchValue} handler={handleSearch}
        />
    )
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, debtors.length - page * rowsPerPage);

    return (
        <div data-testid={`creditors-ageing-summary`}>
            <PageTitle title='Creditors Ageing Summary'/>
            <SubHeader title="Reports" subTitle='Creditors Ageing Summary'>
                <FontAwesomeIcon icon={faClipboardList}/>
            </SubHeader>
            <Container>
                <div className="row">
                    <div className="col-lg-6">
                        <BackButton to='/reports/generalreports' text='General Reports'/>
                    </div>
                    <div className="col-lg-6">
                        <RightAlignedContainer>
                            <DataExportButton isLoading={isLoadingExcel || isLoadingPdf}  downLoadPdf={exportPdf} exportCsv={exportExcel}/>
                        </RightAlignedContainer>
                    </div>
                </div>
                <MainSnackbar variant={type} open={openBar} message={message} handleCloseBar={closeSnackbar}/>
                <MuiPaper>
                    {search_bar}
                    <StickyHeadTable {...{
                        width: '100%',
                        data: debtors,
                        columns: headData.filter(item => Boolean(item)),
                        pagination,
                        parentHeadData:parentHead
                    }}>
                        {isLoading ? <TableRow><TableCell
                            align='center' {...{colSpan: headData.length}}><LoadingGif/></TableCell></TableRow> : null}
                        {isSuccess ? debtors.length > 0 ?
                            <>
                                {debtors.slice(0, rowsPerPage).map((row, index) => {
                                    const count = (page * rowsPerPage) + index + 1;
                                    return (
                                        <TableRow tabIndex={-1} key={index}>
                                            {headData.map(col => (
                                                col.id === 'count' ? <CustomTableCell>{count}</CustomTableCell> :
                                                    <CustomTableCell isBorder={col.isBorder}>{row[col.id]}</CustomTableCell>
                                            ))}
                                        </TableRow>
                                    );
                                })}
                                {emptyRows > 0 && (
                                    <TableRow style={{height: emptyRows}}>
                                        <TableCell colSpan={headData.length}/>
                                    </TableRow>
                                )}
                            </> : <TableRow><TableCell align='center'  {...{colSpan: headData.length}}>No records
                                found</TableCell></TableRow> : null}
                        {isError ?
                            <TableRow><TableCell align='center'  {...{colSpan: headData.length}}>The server did not
                                return a valid response</TableCell></TableRow> : null}
                    </StickyHeadTable>
                </MuiPaper>
            </Container>

        </div>
    )
};

function mapStateToProps(state) {
    return {snackbars: state.snackbar}
}

function mapDispatchToProps(dispatch) {
    return {actions: {snackbarActions: bindActionCreators(snackbarActions, dispatch)}}
}

export default connect(mapStateToProps, mapDispatchToProps)(CreditorsAgeingReport);
